// extracted by mini-css-extract-plugin
module.exports = {"detail-card":"JobStatusOutputCard_detail-card_mTqVy","detail-card-body":"JobStatusOutputCard_detail-card-body_1dDcV"};